import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment-timezone";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Parts} from "components";

function auditQueuePresentation(row) {
	if (row.reviewed === true || Number(row.auditReviewed) === 1) {
		return {status: "Reviewed", open: "View audit", reviewer: row.reviewer || "Admin"};
	}
	if (row.legacy_reviewed) {
		return {status: "Legacy check", open: "Review", reviewer: row.reviewer || "Admin"};
	}
	return {status: "Needs review", open: "Review", reviewer: ""};
}

const breadcrumbs = [
	{name: "Help Desks", url: "/helpdesks", icon: "comments"},
	{name: "Ticket Audit", url: "/helpdesks/audit", icon: "check-square"},
];

class TicketAudits extends Framework.Components.View {
	constructor(props) {
		super(props);
		let filterDate = moment(Date.now()).format();
		try {
			const stored = localStorage.getItem("dateTicketAudit");
			if (stored) {
				filterDate = moment(stored).format();
			}
		} catch (e) {
			filterDate = moment(Date.now()).format();
		}
		this.state = {
			...(this.state || {}),
			filterDate,
			status: "unreviewed",
			items: [],
			loading: true,
			showDate: false,
			loadError: "",
		};
		moment.tz.setDefault("America/Phoenix");
	}

	componentDidMount() {
		this.load();
	}

	componentWillUnmount() {
		this.loadSeq = 0;
	}

	load = async (filterDate = this.state.filterDate) => {
		const seq = (this.loadSeq || 0) + 1;
		this.loadSeq = seq;
		this.setState({loading: true, loadError: "", filterDate});
		try {
			const model = new API.BuildClass(Types.Ticket_Audits._name, API.RequestType.READ_ALL);
			model.filter = {day: filterDate};
			const data = await model.submit(null, "GET_QUEUE");
			if (this.loadSeq !== seq) {
				return;
			}
			const items = Array.isArray(data) ? data : ((data && data.items) || []);
			this.setState({items, loading: false});
			localStorage.setItem("dateTicketAudit", filterDate);
		} catch (e) {
			if (this.loadSeq !== seq) {
				return;
			}
			this.setState({
				loading: false,
				loadError: (e && e.message) || "Unable to load ticket audits.",
			});
		}
	}

	shiftDay = (days) => {
		const filterDate = moment(this.state.filterDate).add(days, "day").format();
		this.setState({items: []});
		this.load(filterDate);
	}

	handleDateChange = (name, date) => {
		this.setState({showDate: false});
		this.load(moment(date).format());
	}

	render() {
		const pickerDate = moment(this.state.filterDate).format("YYYY-MM-DD");
		const rows = (this.state.items || []).filter((row) => {
			const hasAudit = row.reviewed === true || Number(row.auditReviewed) === 1;
			if (this.state.status === "unreviewed") {
				return !hasAudit;
			}
			if (this.state.status === "reviewed") {
				return hasAudit;
			}
			return true;
		});
		const columns = [
			{
				Header: "Ticket",
				id: "pkey",
				accessor: (row) => row.pkey,
				Cell: (props) => (
					<Link to={"/helpdesks/audit/" + props.original.pkey}>{props.original.pkey}</Link>
				),
				width: 110,
			},
			{
				Header: "Customer",
				id: "customer",
				accessor: (row) => row.customer,
			},
			{
				Header: "Field Engineer",
				id: "field_engineer",
				accessor: (row) => row.field_engineer,
			},
			{
				Header: "Appointment",
				id: "appointment_start",
				accessor: (row) => row.appointment_start ? moment(row.appointment_start).format("ddd MMM D, h:mm A") : "",
			},
			{
				Header: "Same Day Cancel",
				id: "same_day_cancel",
				accessor: (row) => row.same_day_cancel ? "Yes" : "",
				width: 140,
			},
			{
				Header: "Status",
				id: "reviewed",
				accessor: (row) => auditQueuePresentation(row).status,
				width: 130,
			},
			{
				Header: "Reviewer",
				id: "reviewer",
				accessor: (row) => auditQueuePresentation(row).reviewer,
			},
			{
				Header: "Open",
				id: "open",
				filterable: false,
				sortable: false,
				width: 110,
				Cell: (props) => (
					<Link to={"/helpdesks/audit/" + props.original.pkey}>
						{auditQueuePresentation(props.original).open}
					</Link>
				),
			},
		];

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Parts.Tickers.HelpdeskTicker/>
				<div className="box-body">
					<div className="table-bar">
						<div className="row rbc-toolbar">
							<div>
								<IconButton onClick={() => this.shiftDay(-1)}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={() => {
									this.setState({items: []});
									this.load(moment(Date.now()).format());
								}}>Today</button>
								<IconButton onClick={() => this.shiftDay(1)}><RightArrowIcon/></IconButton>
							</div>
							<div className="rbc-toolbar-label">
								<label onClick={() => this.setState({showDate: true})}>
									{moment(this.state.filterDate).format("dddd MMM D")}
								</label>
							</div>
							<div style={{display: "flex", gap: 8, alignItems: "center"}}>
								<Button size="sm" color={this.state.status === "unreviewed" ? "primary" : "secondary"} onClick={() => this.setState({status: "unreviewed"})}>Unreviewed</Button>
								<Button size="sm" color={this.state.status === "reviewed" ? "primary" : "secondary"} onClick={() => this.setState({status: "reviewed"})}>Reviewed</Button>
								<Button size="sm" color={this.state.status === "all" ? "primary" : "secondary"} onClick={() => this.setState({status: "all"})}>All</Button>
								<Button size="sm" color="primary" onClick={() => this.load()}>Refresh</Button>
							</div>
						</div>
					</div>
					{this.state.loadError ? <p>{this.state.loadError}</p> : null}
					<ReactTable
						key={this.state.filterDate + "-" + this.state.status}
						columns={columns}
						data={rows}
						loading={this.state.loading}
						defaultPageSize={25}
						pageSizeOptions={[25, 50, 100]}
						minRows={1}
						showPagination={true}
						className="-striped -highlight"
						noDataText="No tickets for this day"
					/>
				</div>
				{this.state.showDate ? (
					<Modal
						isOpen
						toggle={() => this.setState({showDate: false})}
						size="sm"
						backdrop
						style={{display: "none"}}
					>
						<ModalBody>
							<Framework.Elements.Date
								key={pickerDate}
								label="Custom Date"
								value={pickerDate}
								defaultValue={pickerDate}
								update={this.handleDateChange}
								open
								clearable={false}
								cancelLabel=""
							/>
						</ModalBody>
					</Modal>
				) : null}
			</div>
		);
	}
}

export default Framework.Components.withRootState(TicketAudits);
